import { MapboxMarkerType } from '@apps/main/new-desktop/modules/mapbox';
import type {
  Location,
  MapboxMarker,
  StartPositionMarker,
  EndPositionMarker,
} from '@apps/main/new-desktop/modules/mapbox';

import type { IngredientId } from '@libs/trip-planner-interfaces';
import { ConnectionType, MyPositionType } from '@libs/trip-planner-interfaces';

const POSITION_AND_DESTINATION_MARKERS: string[] = [
  MapboxMarkerType.StartPosition,
  MapboxMarkerType.EndPosition,
  MapboxMarkerType.Destination,
];

export function getPrimaryMapMarkers(markers: MapboxMarker[]): MapboxMarker[] {
  return markers.filter((marker) =>
    POSITION_AND_DESTINATION_MARKERS.includes(marker.type)
  );
}

export function createStartPositionMarker(
  location: Location,
  connectionToBeReached: ConnectionType = ConnectionType.NONE
): StartPositionMarker {
  return {
    type: MapboxMarkerType.StartPosition,
    key: `start-location-${location.position.latitude}-${location.position.longitude}`,
    position: location.position,
    connectionToBeReached,
    positionType: MyPositionType.Start,
  };
}

export function createEndPositionMarker(
  location: Location,
  connectionToBeReached: ConnectionType = ConnectionType.NONE
): EndPositionMarker {
  return {
    type: MapboxMarkerType.EndPosition,
    key: `end-location-${location.position.latitude}-${location.position.longitude}`,
    position: location.position,
    connectionToBeReached,
    positionType: MyPositionType.End,
  };
}

export function getIngredientIdFromMarker(
  marker: MapboxMarker
): IngredientId | undefined {
  if (
    marker.type === MapboxMarkerType.Destination ||
    marker.type === MapboxMarkerType.HotelSelection ||
    marker.type === MapboxMarkerType.ActivitySelection
  ) {
    return marker.ingredientId;
  }
  return undefined;
}
